import React, { useContext, useEffect, useState, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { fetchFaldonesByCategoryAndTienda } from "../../../api/files";
import NewSkirtTable from "../../../components/skirt-table/NewSkirtTable";
import { toast } from "../../../helpers/smu-alerts/smu-lerts";
import { StoreContext } from "../../../store/StoreContext";
import SmuButton from "../../../utils/smu-button/SmuButton";
import { useNavigate } from "react-router-dom";
import { getStores } from "../../../api/stores";

const Skirt = () => {
  const navigate = useNavigate();
  const { category } = useParams();
  const { skirts, isAdmin, loggedUser } = useContext(StoreContext);

  const [skirt, setSkirt] = useState(null);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const requestIdRef = useRef(0);
  const [allStores, setAllStores] = useState([]);

  useEffect(() => {
    if (!skirts.length) return;

    // Set skirt based on category only if selected
    if (category){
      const _skirt = skirts.find((s) => s.id === Number(category));
      setSkirt(_skirt);
    }else{
      setSkirt(null)
    }

    // Only fetch files if user and permissions are available
    if (!loggedUser || (!loggedUser?.store && !isAdmin)) return;

    let isActive = true; // fallback for quick unmounts
    const currentRequestId = ++requestIdRef.current;

    const fetchFiles = async () => {
      setLoading(true);
      try {
        const tienda = isAdmin ? null : (loggedUser.store ? loggedUser.store[0] : -1);
        if(isAdmin) {
          getStores().then(({ data }) => {
            setAllStores(data);
          });
        } else {
          setAllStores([]);
        }
        
        const nodeId = category ? category : null;
        const username = loggedUser?.username;
        const { data, error } = await fetchFaldonesByCategoryAndTienda(nodeId, tienda, username);
        
        if (error) throw new Error(error?.message);
        const faldones = (data || []).map(faldon => ({
          ...faldon,
          filename: faldon.FALDON_XLSX.replace(/\.(xlsx|xls)$/i, ''),
          id: faldon.FALDON_XLSX,
          views: faldon.VIEWS,
        }));
        // Only update if this is the latest request
        if (requestIdRef.current === currentRequestId && isActive) {
          setFiles(faldones);
        }
      } catch (err) {
        console.error(err); // Optionally show toast
      } finally {
        if (requestIdRef.current === currentRequestId && isActive) {
          setLoading(false);
        }
      }
    };

    fetchFiles();
    return () => { isActive = false; };
  }, [category, skirts, loggedUser, isAdmin]);

  const handleGetProducts = (faldon, filter = null) => {
    if (filter !== null) {
      navigate(`/promotional-portal/portal/skirt/detail/${faldon.FALDON_XLSX}`, { state: { filter } });
    } else {
      navigate(`/promotional-portal/portal/skirt/detail/${faldon.FALDON_XLSX}`);
    }
  }

  return (
    <Row>
      <Col col={12} className="mb-4">
        <NewSkirtTable title={skirt?.title} files={files} setFiles={setFiles} loading={loading} clickItem={handleGetProducts} allStores={allStores}/>
      </Col>
    </Row>
  );
};

export default Skirt;
